<template>
  <div class="app-container">
    <el-container>
      <el-aside width="240px">
        <el-card shadow="always" :body-style="{ padding: '10px' }">
          <div slot="header">
            <span>组织机构</span>
          </div>
          <el-tree
            ref="orgTree"
            :data="optionData"
            node-key="id"
            default-expand-all
            :props="props"
            :expand-on-click-node="false"
            :current-node-key="searchModel.deptId"
            highlight-current
            @current-change="onOrgChange"
          />
        </el-card>
      </el-aside>

      <el-main height="100%">
        <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
          <el-form-item prop="name" label="关键词">
            <el-input
              v-model="searchModel.name"
              placeholder="输入姓名、手机号等"
              clearable
              @keyup.enter.native="getTableData(true)"
            ></el-input>
          </el-form-item>

          <el-form-item label-width="0" class="form-btn">
            <el-button type="success" @click="getTableData(true)">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>

        <div class="cbox-p14 table-main">
          <TableHeader :refTable="refTable" storageKey="hiddenColumns_user" @onRefresh="getTableData()">
            <el-button v-auth="'user:edit'" type="primary" @click="handleAdd">新增</el-button>
          </TableHeader>

          <el-table ref="table" :data="tableData" stripe border style="width: 100%" height="100%" v-loading="tableLoading">
            <el-table-column label="序号" align="center" width="50">
              <template v-slot="{ $index }">
                <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="login_name" label="登录账号" align="center"></el-table-column>
            <el-table-column prop="mobile" label="手机号码" width="120" align="center"></el-table-column>
            <el-table-column prop="name" label="姓名" align="center"></el-table-column>
            <el-table-column prop="deptName" label="所属部门" align="center"></el-table-column>
            <!-- <el-table-column prop="t4" label="岗位" align="center"></el-table-column> -->
            <el-table-column label="电子签名" width="120" align="center">
              <template v-slot="{ row }">
                <el-image
                  v-if="row.signature"
                  style="width: 80px; height: 50px"
                  :src="$imgUrl + row.signature"
                  :preview-src-list="[$imgUrl + row.signature]"
                ></el-image>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center">
              <template v-slot="{ row }">
                <el-tag :type="row.deleted === 1 ? 'danger' : 'success'">{{ row.deleted === 1 ? '离职' : '在职' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="160" align="center"></el-table-column>

            <el-table-column label="操作" align="center" width="200" fixed="right">
              <template v-slot="{ row }">
                <el-link type="primary" @click="handleDetail(row)">详情</el-link>
                <el-link v-auth="'user:edit'" type="primary" @click="handleEdit(row)">编辑</el-link>
                <el-link v-auth="'user:delete'" type="danger" @click="handleDelete(row)">删除</el-link>
                <el-link v-auth="'user:resetPassword'" type="primary" @click="handleResetPwd(row)">重置密码</el-link>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            :current-page="searchModel.pageNum"
            :page-size="searchModel.pageSize"
            background
            layout="total, prev, sizes ,pager, next, jumper"
            :total="dataTotal"
            @current-change="onCurrentChange"
            @size-change="onSizeChange"
          ></el-pagination>
        </div>
      </el-main>
    </el-container>

    <!-- 新增/编辑 用户信息 -->
    <UserEdit :visible.sync="editVisible" :activeId="activeRowId" @refresh="getTableData()" />
    <!-- 用户详情 -->
    <UserDetail :visible.sync="detailVisible" :activeId="activeRowId"></UserDetail>
    <!-- 修改密码 -->
    <PasswordReset :visible.sync="resetPwdVisible" :user="resetUser"></PasswordReset>
  </div>
</template>

<script>
import TableHeader from '@/components/TableHeader';
import UserEdit from './components/UserEdit';
import UserDetail from './components/UserDetail';
import PasswordReset from './components/PasswordReset';

import { getOrgData } from '@/api/user';
import { getUserList, deleteUser } from '@/api/user';

export default {
  components: { TableHeader, UserEdit, UserDetail, PasswordReset },
  props: {},
  data() {
    return {
      refTable: null,
      optionData: [],
      props: {
        value: 'id',
        label: 'text',
        children: 'nodes'
      },
      searchModel: {
        name: '',
        pageNum: 1,
        pageSize: 20,
        deptId: null
      },
      tableLoading: false,
      dataTotal: 0,
      tableData: [],
      tableSelection: [],
      activeRowId: null,
      editVisible: false,
      detailVisible: false,
      resetPwdVisible: false,
      resetUser: {}
    };
  },
  computed: {},
  watch: {},
  methods: {
    /******** 组织架构 Start ********/
    onOrgChange(data) {
      this.searchModel.deptId = data.id;
      this.getTableData(true);
    },
    async getOrgData() {
      const data = await getOrgData();
      this.optionData = data || [];
    },
    /******** 组织架构 End ********/
    /******** 列表数据 Start ********/
    handleReset() {
      this.searchModel.deptId = null;
      this.$refs.orgTree.setCurrentKey(null);
      this.$refs.searchModel.resetFields();
      this.getTableData(true);
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;

      this.tableLoading = true;
      const { data } = await getUserList(this.searchModel);

      this.tableData = data.list || [];
      this.dataTotal = data.count || 0;
      this.tableLoading = false;
    },
    // 详情
    handleDetail(row) {
      this.activeRowId = row.id;
      this.detailVisible = true;
    },
    handleAdd() {
      this.activeRowId = null;
      this.editVisible = true;
    },
    handleEdit(row) {
      this.activeRowId = row.id;
      this.editVisible = true;
    },
    handleResetPwd(user) {
      this.resetUser = user;
      this.resetPwdVisible = true;
    },
    handleDelete(row) {
      this.$confirm(`您确认要删除该用户吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteUser(row.id);
        this.$message.success('删除用户成功！');
        this.getTableData();
      });
    }
    /******** 列表数据 End ********/
  },
  created() {},
  mounted() {
    this.refTable = this.$refs.table;
  },
  activated() {
    this.getOrgData();
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>
<style lang="scss" scoped>
.el-container {
  height: 100%;
}

.el-aside {
  height: 100%;
  ::v-deep .el-card {
    height: 100%;

    .el-card__body {
      padding: 20px;
      height: calc(100% - 56px);
      overflow-y: auto;
    }
  }
}

.el-main {
  padding: 0 0 0 10px;
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
}
</style>
